export default __webpack_public_path__ + "static/media/shop_1.cdf51282.gif";